import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { filter, map, Subject } from 'rxjs';
import { match } from 'ts-pattern';
import { routes } from '../../data/routes';
import { useSubscription } from '../hooks/useSubscription';
import { BusEvent } from './EditorContext';

export type NavigatorEvent = 'Root' | 'Invitations';

export const useNavigator = (bus$: Subject<BusEvent>) => {
  const navigate = useNavigate();

  const navigatorEvent$ = useMemo(
    () =>
      bus$.pipe(
        filter((e) => e.type === 'Navigator'),
        map((e) => (e as { type: 'Navigator'; event: NavigatorEvent }).event) // Potentially add throttling.
      ),
    [bus$]
  );

  useSubscription(
    () =>
      navigatorEvent$.subscribe((e) =>
        match(e)
          .with('Root', () => navigate(routes.root))
          .with('Invitations', () => navigate(routes.invitations))
          .exhaustive()
      ),
    [navigatorEvent$, navigate]
  );
};
